import { Injectable } from '@angular/core';
import { HandleError, HttpErrorHandlerService } from '../http-error-handler.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AppointmentForEmpService {
  private handleError: HandleError;
  private baseUrl = 'http://localhost:8060/appointment';
  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService
  ) {
    this.handleError = httpErrorHandler.createHandleError('AppointmentForEmpAPIService');
  }
}
